import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("rect", { width: 20, height: 20, rx: 2, fill: "#C1F5B7" }),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.209 9.872l-5.223-5.845a1.455 1.455 0 00-.958-.427 1.455 1.455 0 00-.958.427L3.848 9.893a.752.752 0 00-.248.566.743.743 0 00.265.558.767.767 0 00.9.07.758.758 0 00.23-.218l4.032-4.512a.136.136 0 01.152-.037.135.135 0 01.086.123v9.205a.743.743 0 00.224.532.765.765 0 00.54.22.773.773 0 00.539-.22.752.752 0 00.223-.532V6.443a.135.135 0 01.087-.123.137.137 0 01.152.037l4.032 4.512a.764.764 0 00.525.254.775.775 0 00.554-.187.757.757 0 00.258-.518.743.743 0 00-.19-.546z",
      fill: "#238312"
    }
  )
);
export {
  a as default
};
